// 初始化项目的时候填入的变量, 请谨慎修改, 会影响各个地方的使用
export var componentName = 'ReactionsBuilder';
export var libraryName = 'reactions-builder';
export var ALL_FIELDS_KEY = '$ALL_FIELDS';

// ${conditionValue} 为判断的条件值的字符串插槽Slot
export var CONDITION_OPTIONS = [{
  label: '值等于',
  value: '$self.value==${conditionValue}'
}, {
  label: '值不等于',
  value: '$self.value!=${conditionValue}'
}, {
  label: '包含',
  value: '$self.value.includes(${conditionValue})'
}, {
  label: '不包含',
  value: '!$self.value.includes(${conditionValue})'
}, {
  label: '为空',
  value: '!$self.value',
  hiddenValue: true
}, {
  label: '不为空',
  value: '!!$self.value',
  hiddenValue: true
}];
export var REACTION_CONFIG_LAYOUT = [{
  title: '条件',
  span: 8
}, {
  title: '联动',
  span: 14
}, {
  title: '操作',
  span: 2
}];
export var FIELD_STATE_OPTIONS = [{
  label: '值相关',
  children: [{
    label: '初始值',
    value: 'initialValue'
  }, {
    label: '赋值',
    value: 'value'
  }, {
    label: '枚举项',
    value: 'dataSource'
  }]
}, {
  label: '字段状态',
  children: [{
    label: '显示',
    value: 'visible'
  }, {
    label: '隐藏UI,保留数据',
    value: 'hidden'
  }, {
    label: '隐藏UI,删除数据',
    value: 'none'
  }]
}, {
  label: '显示形态',
  children: [{
    label: '可编辑',
    value: 'editable'
  }, {
    label: '禁用',
    value: 'disabled'
  }, {
    label: '只读',
    value: 'readOnly'
  }, {
    label: '阅读态',
    value: 'readPretty'
  }]
}];
export var FORMILY_HOOKS = [{
  label: '字段钩子',
  children: [{
    label: '字段初始化',
    value: 'onFieldReact'
  }, {
    label: '字段值变化',
    value: 'onFieldValueChange'
  }, {
    label: '输入框失焦时',
    value: 'onFieldChange_active_false'
  }]
}, {
  label: '表单钩子',
  isFormHooks: true,
  children: [{
    label: '表单初始化',
    value: 'onFormInit'
  }, {
    label: '表单值变化',
    value: 'onFormValuesChange'
  }, {
    label: '表单字段输入',
    value: 'onFormInputChange'
  }]
}];
export var InitData = {
  fromDataSource: false,
  syncData: '',
  asyncData: {}
};

// 请求入参选项formValue
export var __formValue__ = '__formValue__';

// 请求入参选项低码L2 state
export var __dataSource__ = '__dataSource__';

// 请求入参选项可编辑表格
export var __arrayTableCurrentRow__ = '__arrayTableCurrentRow__';

// 请求入参字典
export var RequestParamsMap = {
  'FORM': {
    name: '表单',
    group: __formValue__,
    // 与低码L2保持一致
    param: 'CnForm',
    placeholder: '请输入字段编码'
  },
  'URLPARAM': {
    name: 'URL查询参数',
    group: __dataSource__,
    // 与低码L2保持一致
    param: 'urlParams',
    placeholder: '请输入URL查询参数'
  },
  'STATICSTRING': {
    name: '字符串',
    group: '__staticString__',
    param: 'staticString',
    placeholder: '请输入静态值'
  },
  'JSEXPN': {
    name: 'JS表达式',
    group: '__jsExpression__',
    param: 'jsExpression',
    placeholder: '请输入URL查询参数'
  }
};

// 与、或的字典映射
export var OperatorMap = {
  AND: '&&',
  OR: '||'
};